/** IMS user auth headers for outbound HTTP and WebSocket frames. */
export function buildUserAuthHeaders(
  imsToken?: string,
  options?: { contentType?: boolean },
): Record<string, string> {
  const headers: Record<string, string> = {};
  if (options?.contentType !== false) {
    headers["Content-Type"] = "application/json";
  }
  if (imsToken) {
    headers.Authorization = `Bearer ${imsToken}`;
    headers["x-user-token"] = imsToken;
  }
  return headers;
}

/** Auth fields on browser → bridge WebSocket frames (no ims_token body field). */
export interface FrameAuthFields {
  Authorization: string;
  "x-user-token": string;
}

export function buildFrameAuthFields(imsToken: string): FrameAuthFields {
  const headers = buildUserAuthHeaders(imsToken, { contentType: false });
  return {
    Authorization: headers.Authorization,
    "x-user-token": headers["x-user-token"],
  };
}

type AuthSource = {
  Authorization?: string;
  "x-user-token"?: string;
};

/** Resolve IMS user token from x-user-token or Authorization Bearer. */
export function extractImsToken(source: AuthSource): string | undefined {
  if (source["x-user-token"]) {
    return source["x-user-token"];
  }
  const authorization = source.Authorization;
  if (!authorization) {
    return undefined;
  }
  if (authorization.startsWith("Bearer ")) {
    return authorization.slice("Bearer ".length);
  }
  return authorization;
}

/** Read auth from an HTTP upgrade request (when a gateway forwards headers). */
export function extractImsTokenFromUpgradeRequest(headers: {
  authorization?: string;
  Authorization?: string;
  "x-user-token"?: string;
}): string | undefined {
  return extractImsToken({
    Authorization: headers.authorization ?? headers.Authorization,
    "x-user-token": headers["x-user-token"],
  });
}
